import { AddressDetailsModel } from "app/data/address-manager/models";

export interface ApiStatus {
    isLoading: boolean;
    isSuccess: boolean;
    isError: boolean;
    errorMessage: string | null;
  }
  
  export interface AddressState {
    list: ApiStatus;
    byId: ApiStatus;
  
    data: any[];
    resultCount: number;
    selectedAddressId: string | null;
    selectedAddress: AddressDetailsModel | null;
    searchString: string;
  }
  
  export const initialState: AddressState = {
    list: { isLoading: false, isSuccess: false, isError: false, errorMessage: null },
    byId: { isLoading: false, isSuccess: false, isError: false, errorMessage: null },
  
    data: [],
    resultCount: 0,
    selectedAddressId: null,
    selectedAddress: null,
    searchString: ""
  };
  